import React from 'react';
import { BitwerxOfferingsTableProps } from './types';
import { styles } from './styles';
import { Table, Column } from '@v2/components';
import { BitwerxOffering } from '@v2/types';

const columns: Column<BitwerxOffering>[] = [
  {
    key: 'name',
    header: 'Offerings',
    sortKey: 'name',
    render: row => (
      <div className={styles.nameContainer}>
        <span className={styles.name}>{row.name}</span>
      </div>
    ),
  },
  {
    key: 'subOfferings',
    header: 'Sub-offerings',
    render: row => <span className={styles.subCount}>{row.subOfferings?.length ?? 0}</span>,
  },
];

const BitwerxOfferingsTable: React.FC<BitwerxOfferingsTableProps> = ({
  offerings,
  loading,
  error,
  onSelectOffering,
  selectedOfferingId,
  sortConfig,
  onSortChange,
  search,
  onSearchChange,
  searchPlaceholder,
}) => (
  <Table<BitwerxOffering>
    columns={columns}
    data={offerings}
    keyExtractor={offering => offering.id}
    loading={loading}
    error={error}
    emptyMessage="No Bitwerx offerings found."
    onRowClick={onSelectOffering}
    selectedKeys={selectedOfferingId ? [selectedOfferingId] : []}
    sortConfig={sortConfig ?? null}
    onSortChange={onSortChange}
    search={search}
    onSearchChange={onSearchChange}
    searchPlaceholder={searchPlaceholder}
  />
);

export default BitwerxOfferingsTable;
